import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { settingsPageStyles } from "component/shared/settings-page";

export const styles = (theme: Theme) => {
	return ({
		...settingsPageStyles(theme),
		// Figma 1702:25626: title, then 16px to the description, then 24px to a right-aligned
		// Restore Defaults, then 24px to the table (MAX-4337).
		emailsTitle: {
			marginBottom: 16,
		},
		emailsDescription: {
			marginBottom: 24,
		},
		restoreRow: {
			display: "flex",
			justifyContent: "flex-end",
			marginBottom: 24,
		},
		// Tertiary button: Semibold 16/20 in the teal tertiary-action color.
		restoreDefaults: {
			textTransform: "none",
			fontSize: 16,
			fontWeight: 600,
			lineHeight: "20px",
			color: theme.palette.custom.tertiaryAction,
			padding: 0,
			minWidth: 0,
		},
		toggleLabel: {
			fontWeight: "bold",
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
		},
		toggleDescription: {
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
			marginTop: 4,
		},
		// The divider sits between the Text & Summary card and the emails section, outside both, 32px
		// from each. The card's wrapper already contributes 16px below it (MAX-4337).
		sectionDivider: {
			marginTop: 16,
			marginBottom: 32,
		},
		frequency: {
			maxWidth: 576,
			marginTop: 16,
			marginLeft: 64,
		},
	} satisfies Record<string, CSSObject>);
};
